import { mapState } from 'vuex';
import n20ActionButtonMixin from './n20ActionButtonMixin';
export default {
  name: 'CoreN20Dialog',
  mixins: [n20ActionButtonMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: [Number, String],
      default: 900
    },
    persistent: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    actionSaveLabel: {
      type: String,
      default: ''
    },
    actionSaveLoading: {
      type: Boolean,
      default: false
    },
    actionSaveDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    cloading() {
      return this.$store.state.app.loading;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    hasCloseListener() {
      return this.$listeners && this.$listeners.close;
    },
    hasSaveListener() {
      return this.$listeners && this.$listeners['action:save'];
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    closeOnEscape(ev) {
      if (!this.persistent && ev.key === 'Escape') {
        this.closeDialog();
      }
    },
    closeOnClickOutSide() {
      if (!this.persistent) {
        this.closeDialog();
      }
    }
  }
};